import { SubcontractCOFormItem } from '@/src/app/Interfaces/Accounting/ACForms.interfaces';
import { InputText } from 'primereact/inputtext';
import React, { useEffect, useState } from 'react';

type DescriptionProps = {
  item: SubcontractCOFormItem;
  updateItems: (item: SubcontractCOFormItem) => void;
  showError?: boolean;
  disabled?: boolean;
};

const Description = ({
  item,
  updateItems,
  showError,
  disabled,
}: DescriptionProps) => {
  const [value, setValue] = useState(item.description ?? '');
  const hasError = showError && (!value || value.length > 60);

  useEffect(() => {
    const description = item.description ?? '';
    setValue((value) => (value !== description ? description : value));
  }, [item.description]);

  return (
    <React.Fragment>
      <InputText
        value={value}
        autoComplete="off"
        className={`w-full blackText text-standard ${
          hasError && 'p-invalid'
        } printHide`}
        onChange={(e) => {
          setValue(e.target.value);
        }}
        onBlur={() => {
          if (item.description !== value) {
            item.description = value;
            updateItems(item);
          }
        }}
        disabled={!item.isNew || disabled}
        tooltip={
          value.length > 60
            ? 'The description cannot be longer than 60 characters!'
            : undefined
        }
      />
      <span className="printMedia printShow">{value}</span>
    </React.Fragment>
  );
};

export default Description;
